import * as angular from "angular";

import { formatTimeZoneOffset } from "../utils/timeZoneOffset";

export function formatTimeZoneOffsetFilter(): typeof formatTimeZoneOffset {
	return formatTimeZoneOffset;
}

export default angular
	.module("vesl.filters.formatTimeZoneOffset", [])
	.filter("formatTimeZoneOffset", formatTimeZoneOffsetFilter)
	.name;
